module.exports = __webpack_public_path__ + "static/media/objective_expansion_arrow.686d11f1.svg";